"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tree_utils_1 = require("../../common/tree-utils");
var idm_reporting_service_client_js_1 = require("@synisys/idm-reporting-service-client-js");
/**
 * Set column tree map to row formatting rules
 *
 * Created by Hayk.Andriasyan on 5/17/2018.
 */
var RowFormattingRulesColumnTreeSetter = /** @class */ (function () {
    function RowFormattingRulesColumnTreeSetter() {
    }
    RowFormattingRulesColumnTreeSetter.setColumnTreeToRowFormattingRules = function (reportViewStyles, columnRootDto, columnBranchIndexes) {
        /**
         * Map where key is branch index before execution,
         * value is branch indexes after execution
         *
         * for example if columnBranchIndex = [0,0,1,1,1,2,2]
         * map will be { 0 => [0, 1], 1 => [2, 3, 4], 2 => [5, 6] }
         */
        var measureAndBranchIndexes = new Map();
        var metadataToRealIndex = {};
        for (var num = 0; num < columnBranchIndexes.length; num++) {
            var metadataIndex = columnBranchIndexes[num];
            if (metadataIndex in metadataToRealIndex) {
                metadataToRealIndex[metadataIndex].push(num);
            }
            else {
                metadataToRealIndex[metadataIndex] = [num];
            }
        }
        var rootChildren = columnRootDto.children;
        var branchIndex = 0;
        for (var i = 0; i < rootChildren.length; i++) {
            if (rootChildren[i] instanceof idm_reporting_service_client_js_1.ColumnMeasureDto) {
                measureAndBranchIndexes.set(branchIndex, metadataToRealIndex[branchIndex]);
            }
            branchIndex += tree_utils_1.TreeUtils.getColumnTreeLeafsCount(rootChildren[i]);
        }
        var branchStyles = reportViewStyles.rowBranchStylesDto;
        if (branchStyles) {
            for (var _i = 0, branchStyles_1 = branchStyles; _i < branchStyles_1.length; _i++) {
                var style = branchStyles_1[_i];
                for (var _a = 0, _b = Array.from(style.categoriesStyle.values()); _a < _b.length; _a++) {
                    var categoryStyle = _b[_a];
                    categoryStyle.rowFormattingRule.setColumnsTree(measureAndBranchIndexes);
                }
            }
        }
    };
    return RowFormattingRulesColumnTreeSetter;
}());
exports.RowFormattingRulesColumnTreeSetter = RowFormattingRulesColumnTreeSetter;
//# sourceMappingURL=row-formatting-rules-column-tree-setter.js.map